// React Query hooks for audit log viewer (ADM-012)
import { useQuery } from '@tanstack/react-query'
import * as auditLogApi from '@/api/auditLog'

export const useAuditLog = (params: auditLogApi.AuditLogParams) => {
  return useQuery({
    queryKey: ['audit-log', params],
    queryFn: () => auditLogApi.fetchAuditLog(params),
    placeholderData: (prev) => prev,
  })
}

export const useAuditLogFilters = () => {
  return useQuery({
    queryKey: ['audit-log-filters'],
    queryFn: auditLogApi.fetchAuditLogFilters,
    staleTime: 60_000, // filter options change rarely
  })
}
